"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLeverageConfigRow = exports.useLeverageConfig = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const errors_1 = require("../../../interface/errors");
const leverageMap = new Map();
const queryLeverageConfigureWithCache = (symbol) => {
    if (!symbol) {
        return (0, rxjs_1.throwError)({ code: "-1", message: "no symbol filled" });
    }
    const cache = leverageMap.get(symbol);
    if (cache) {
        return (0, rxjs_1.of)(cache);
    }
    return (0, trade_utils_lib_1.requestWithRetry)(() => (0, FutureAPI_1.queryLeverageConfigure)(symbol), { maxRetryCount: 2, name: "queryLeverageConfigure-" + symbol }).pipe((0, operators_1.map)((res) => {
        if (res && res.length && res[0].symbol === symbol) {
            const value = res[0];
            leverageMap.set(symbol, value);
            return value;
        }
        throw errors_1.TRADE_NOT_HAVE_LEVERAGED_CONFIG;
    }));
};
/** 没有 config 也没有 error 的时候 是loading */
const useLeverageConfig = (symbol) => {
    const [config, setConfig] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        setConfig(undefined);
        setError(undefined);
        const sub = queryLeverageConfigureWithCache(symbol).subscribe({
            next: (config) => {
                setConfig(config);
                setError(undefined);
            },
            error: (err) => {
                setConfig(undefined);
                setError(err);
            },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [symbol]);
    return { leverageConfig: config, leverageError: error };
};
exports.useLeverageConfig = useLeverageConfig;
const DefaultMaxLeverage = 5;
/**
 * 获取合约杠杆倍数相关配置
 * @param symbol 当前交易对
 * @param leverage 当前杠杆倍数
 * @returns maxLeverage: 最大杠杆倍数, curLeverageRow: 当前杠杆倍数所处配置, leverageConfig: 该交易对总配置, leverageError: 错误
 */
const useLeverageConfigRow = (symbol, leverage) => {
    var _a;
    const { leverageConfig, leverageError } = (0, exports.useLeverageConfig)(symbol);
    const result = (0, react_1.useMemo)(() => {
        if (!leverageConfig || !leverageConfig.rows || !leverageConfig.rows.length) {
            return;
        }
        // 以最大杠杆倍数升序 exam: 1,2,3
        const sortRows = leverageConfig.rows.sort((a, b) => Number(a.max_leverage) - Number(b.max_leverage));
        const maxLeverage = Number(sortRows[sortRows.length - 1].max_leverage);
        let curRow = undefined;
        if (Number(leverage)) {
            curRow = sortRows.find((e) => {
                return Number(leverage) <= Number(e.max_leverage);
            });
        }
        return { maxLeverage: maxLeverage, curLeverageRow: curRow };
    }, [leverage, leverageConfig]);
    return {
        maxLeverage: (_a = result === null || result === void 0 ? void 0 : result.maxLeverage) !== null && _a !== void 0 ? _a : DefaultMaxLeverage,
        curLeverageRow: result === null || result === void 0 ? void 0 : result.curLeverageRow,
        leverageConfig: leverageConfig,
        leverageError: leverageError,
    };
};
exports.useLeverageConfigRow = useLeverageConfigRow;
